import _ from 'lodash';
import { FETCH_RESINS_FULFILLED } from '../../actions/action-types';
import * as fromResin from './resin';

function resins(state = [], action){
  switch(action.type){
    case FETCH_RESINS_FULFILLED:
      return action.payload;
    default:
      return state;
  }
}

export default resins;

export function getManufacturers(state){
  return _.chain(state)
    .map(resin => ({
      label: resin.manufacturer,
      value: resin.manufacturerId,
    }))
    .uniqBy(manufacturer => manufacturer.value)
    .value();
}

export function getResinsWithManufacturerId(state, manufacturerId) {
  if (manufacturerId === undefined) {
    return [];
  }

  return _.chain(state)
    .filter(resin => resin.manufacturerId === manufacturerId)
    .map(resin => ({
      label: resin.product,
      value: resin.id,
    }))
    .value();
}

export function getResinById(state, id) {
  return state.find(resin => resin.id === id);
}

export function getDefaultCore(state, id){
  if (id === undefined) {
    return undefined;
  }
  const resin =  getResinById(state, id);
  return fromResin.getDefaultCore(resin);
}

export function getDefaultPrepreg(state, id){
  if (id === undefined) {
    return undefined;
  }
  const resin =  getResinById(state, id);
  return fromResin.getDefaultPrepreg(resin);
}

export function getCoreOptionsByResinId(state, resinId) {
  const resin = getResinById(state, resinId);
  if (resin === undefined) {
    return [];
  }
  return fromResin.getCores(resin);
}

export function getPrepregOptionsByResinId(state, resinId) {
  const resin = getResinById(state, resinId);
  if (resin === undefined) {
    return [];
  }
  return fromResin.getPrepregs(resin);
}



// WEBPACK FOOTER //
// ./src/reducers/resins/index.js